import { CrmView } from './CrmView';
import { useCrm } from './useCrm';

/**
 * CRM (design slIsCrm, T6743-7353; salesVals L20936-21675). One workspace: the rail (My
 * day, All deals, Companies, People, Customers, Health, Snoozed, Lost, then saved views),
 * the main area (My day, the deals table or the drag board, the catalog, People, the
 * Customers and Health panels) and the right panel (the selected deal or facility), with
 * the Email & calendar drawer and the contact and company drawers. Everything reads and
 * writes the live CRM; the server enforces ownership and the stage gates.
 */
export function CrmTab() {
  const v = useCrm();
  return <CrmView v={v} />;
}
